import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  OnDestroy, OnInit,
  ViewChild
} from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { ConfigService } from '@xilo-mono/common/config';
import { CsvImporterComponent } from '@xilo-mono/csv-importer';
import { getFlattenedFieldsWithDetails } from '@xilo-mono/form-helper';
import { flattenDeep } from 'lodash';
import { ReplaySubject, takeUntil } from 'rxjs';
import { FormViewService } from '@xilo-mono/form-contracts';

@Component({
  selector: 'xilo-mono-form-viewer-section-wrapper-panel',
  templateUrl: './section-wrapper.component.html',
  styleUrls: ['./section-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormViewerSectionPanelWrapperComponent
  extends FieldWrapper
  implements OnDestroy, OnInit {
  @ViewChild('importer') importer: CsvImporterComponent;

  activeUser = {
    id: '1',
    name: 'Form Filler',
    email: 'customer-sucess@xilo.io',
    companyId: '1',
    companyName: 'Form Filler'
  };

  uploadClicked = false;
  openedAccordion = new Set();

  private readonly destroyed$ = new ReplaySubject<boolean>(1);

  get dromoLicenseKey(): string {
    return this.configService.dromoLicenseKey;
  }

  constructor(
    private configService: ConfigService,
    private formViewService: FormViewService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this.formViewService.openedAccordions$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(openSet => {
        this.openedAccordion = openSet;
        this.cdr.markForCheck();
      });
  
    this.formViewService.fieldIdsWithErrorInIntakeForm$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(fieldsToOpen => {
        if (fieldsToOpen) {
          this.formViewService.mergeAccordionsToOpen(fieldsToOpen);
        }
      });
      if (this.formViewService.shouldOpenAllSections() && this.field?.id) {
        this.formViewService.updateOpenedAccordions(this.field.id, true);
      }
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }

  openDromo() {
    const type = 'intake-form';
    const fieldGroup = [this.field];

    this.uploadClicked = true;
    const fieldGroups = getFlattenedFieldsWithDetails(type, fieldGroup);

    const flattenedFieldGroup = flattenDeep(fieldGroups);
    const dromoFields = [];
    const fieldsCopy = [];
    for (const question of flattenedFieldGroup) {
      dromoFields.push({
        label: question.fieldLabel,
        key: question.fieldKey
      });
      fieldsCopy.push(question);
    }
    if (fieldsCopy.length > 0 && dromoFields.length > 0) {
      this.importer.openDromo(dromoFields, fieldsCopy);
    } else {
      // this.toastService.showMessage('Could not load form');
    }
  }

  onCancelImport() {
    this.uploadClicked = false;
  }

  onCompletedImport(params: any) {
    const { newFields } = params;
    for (let i = 0; i < newFields.length; i++) {
      const section = newFields[i];
      const fieldToImport = {};
      if (section.some((f) => f.value)) {
        for (const f of section) {
          if (f.value) {
            fieldToImport[f.fieldKey] = f.value;
          } else {
            fieldToImport[f.fieldKey] = null;
          }
        }
      }
      if (Object.keys(fieldToImport).length > 0) {
        this.field.parent.templateOptions.onAdd(i, fieldToImport, true);
      }
    }
  }

  openChanged(open: boolean) {
    this.formViewService.updateOpenedAccordions(this.field.id, open);
  }
}
